import { render, staticRenderFns } from "./DistributorsSellsTable.vue?vue&type=template&id=07181f84&"
import script from "./DistributorsSellsTable.vue?vue&type=script&lang=js&"
export * from "./DistributorsSellsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports